



















import Component, { mixins } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { VehicleType } from '@/core/interfaces/vehicleType';
import { NotificationType } from '@/core/interfaces/notificationType';
import { Farm } from '@/core/interfaces/farm';
import { knowledgeBaseUrl } from '@/core/newAppUrl';
import axios from 'axios';
import UsesNotificationMessage from '@/components/mixins/UsesNotificationMessage';

@Component
export default class KnowledgeBaseLink extends mixins(UsesNotificationMessage) {
    @Prop({ required: true })
    mode!: 'farm-vehicle-type' | 'notification-type';

    @Prop({ required: true })
    vehicleType!: VehicleType;

    @Prop()
    notificationType!: NotificationType;

    @Prop()
    farm!: Farm;

    knowledgeBasePage: string | null = null;

    @Watch('knowledgeBasePageLink', { immediate: true })
    async fetchKnowledgeBasePage(): Promise<void> {
        try {
            const response = (await axios.get(this.knowledgeBasePageLink, {
                headers: {
                    'X-Lely-Skip-Auth-Interceptor': 'true',
                },
            }));

            this.knowledgeBasePage = response.data;
        } catch (e) {
            this.knowledgeBasePage = null;
        }
    }

    get hasKnowledgeBasePage(): boolean {
        return !!this.knowledgeBasePage;
    }

    get knowledgeBasePageLink(): string {
        return this.mode === 'farm-vehicle-type'
            ? `vehicle-types/${this.vehicleType.id}/farms/${this.farm.id}/page`
            : `notification-types/${this.notificationType.id}/page`;
    }

    // The knowledge base moved to its own app; without a page yet, its editor opens straight away.
    get knowledgeBaseLink(): string {
        const vehicleTypeName = encodeURIComponent(this.vehicleType?.name);
        const path = this.mode === 'farm-vehicle-type'
            ? `/${vehicleTypeName}/farm/${this.farm.id}`
            : `/${vehicleTypeName}/${this.notificationType.code}`;

        return knowledgeBaseUrl(path, { create: this.hasKnowledgeBasePage ? undefined : 'true' });
    }

    get popover(): { html: boolean; content: string; title: string } | null {
        if (!this.hasKnowledgeBasePage) {
            return null;
        }

        // Parsed without rendering, so the page's (possibly relative) image URLs aren't fetched
        const page = new DOMParser().parseFromString(this.knowledgeBasePage || '', 'text/html');
        let content = (page.body.textContent || '').substring(0, 250);

        if (content.length === 250) {
            content += '...';
        }

        const title = this.mode === 'farm-vehicle-type'
            ? `${this.farm.name} - ${this.vehicleType.name}`
            : `${this.notificationType.code} - ${this.notificationMessage}`;

        return {
            html: true,
            content,
            title,
        };
    }
}
